import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { TeamMembership } from '@/react/portainer/users/teams/types';

import { UserId } from './types';
import { buildUrl } from './buildUrl';

export async function getUserMemberships(id: UserId) {
  try {
    const { data } = await axios.get<TeamMembership[]>(
      buildUrl(id, 'memberships')
    );
    return data;
  } catch (err) {
    throw parseAxiosError(err as Error, 'Unable to retrieve user memberships');
  }
}
